import { RawKey } from '@master/annotation/RawKey'
import { Meta } from '@master/model/common/Meta'

export class PolicyDocumentMeta extends Meta {
  @RawKey('_oid')
  oid = ''

  policyOid = ''
  fileName = ''
  documentType = ''
  ctm: number = undefined
}
